<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useSmartCampaignsStore } from 'dashboard/stores/smartCampaigns';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import SmartCampaignForm from './SmartCampaignForm.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useSmartCampaignsStore();

const dialogRef = ref(null);
const formRef = ref(null);

const isSubmitDisabled = computed(() => formRef.value?.isSubmitDisabled);

const handleSubmit = async () => {
  const details = await formRef.value?.handleSubmit();
  if (!details) return;

  try {
    await store.update({ id: props.selectedCampaign.id, ...details });
    useAlert(t('SMART_CAMPAIGNS.EDIT.API.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch {
    useAlert(t('SMART_CAMPAIGNS.EDIT.API.ERROR_MESSAGE'));
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('SMART_CAMPAIGNS.EDIT.TITLE')"
    :disable-confirm-button="isSubmitDisabled"
    :confirm-button-label="t('SMART_CAMPAIGNS.EDIT.BUTTONS.SAVE')"
    :cancel-button-label="t('SMART_CAMPAIGNS.CREATE.BUTTONS.CANCEL')"
    width="6xl"
    overflow-y-auto
    @confirm="handleSubmit"
  >
    <SmartCampaignForm
      ref="formRef"
      mode="edit"
      :selected-campaign="selectedCampaign"
    />
  </Dialog>
</template>
